import styles from './BrandIcon.module.scss';

export const BrandIcon = () => {
  return <div className={styles.root}>APT KING</div>;
};
